import { WorkBook } from "xlsx-js-style";
import { ExcelTemplate } from "../../interfaces";
import * as XLSX from 'xlsx-js-style';
import { CommitmentAllocationModelExcelExport } from "src/app/domain/follow-on/component/commitment-allocation-model-table/commitment-allocation-model-table.component";
import { getPreparedData } from "./mapping";
import { setColumnWidth, withHeaderStyling } from "../../utils";
import { fitToColumn } from "../financial-statement/utils";

export class FollowOnModelTableTemplateStepThree implements ExcelTemplate {
  export(data: CommitmentAllocationModelExcelExport): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheetStepThree(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  getSheetStepThree(data: CommitmentAllocationModelExcelExport): XLSX.WorkSheet {
    const exportExcelData = getExcelExportData(data);
    const preparedData = getPreparedData(exportExcelData);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndexses = [1, 6, 10];
    whiteSpaceIndexses.forEach((index) => setColumnWidth(sheet, index, 1));
    return withHeaderStyling(sheet);
  }

};

const getExcelExportData = (data: CommitmentAllocationModelExcelExport) : FollowOnModelDtoForExcel => {
  const exportData: FollowOnModelDtoForExcel = {
    upperHeaders: getUpperHeaders(),
    headersForLogic: getHeaderForLogic(),
    headersForDisplay: getHeadersForDisplay(),
    data,
  };
  return exportData;
};

const getUpperHeaders = (): string[] => {
  return [null,
    null, '', 'Current', '', '', null,
    '', 'Delta', '', null,
    '', 'Prediction', ''];
};

const getHeadersForDisplay = (): string[] => ['Company', null, 'Investment', 'Fair value', 'MOIC', 'Comp.value', null,
  'Investment', 'Fair value', 'MOIC', null,
  'Investment', 'Fair value', 'MOIC'];

const getHeaderForLogic = (): string[] => ['Company', 'Empty', 'Investment', 'Fair value', 'MOIC', 'Comp.value', 'Empty(0)',
  'Investment(0)', 'Fair value(0)', 'MOIC(0)', 'Empty(1)',
  'Investment(1)', 'Fair value(1)', 'MOIC(1)'];

export interface FollowOnModelDtoForExcel {
  headersForLogic: string[];
  headersForDisplay: string[];
  upperHeaders: string[];
  data: CommitmentAllocationModelExcelExport;
}
